import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Money } from 'ha/services/apiV2/types/common';
import { APIV2_URL } from '../constants';
import { PayInResource } from './types';

export type Payload = {
  settlementReference: string;
  paymentMethodUUID: string;
  value: Money;
};

export type Response = PayInResource;

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Response>('POST', `${APIV2_URL}/payment/pay-in`, { data });
